import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrintEgui } from '../../store/orders-type.actions';
import { selectDetailOrder } from '../../store/orders-type.selectors';

import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'order-egui',
    templateUrl: './order-egui.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderEguiComponent {
    public eguiRequested = this.modalRef.data.hasBeenRequested;

    public eguiRequestedDate$ = this.store.select(selectDetailOrder);

    constructor(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-arguments
        private readonly modalRef: DialogRef<void, any>,
        private readonly store: Store,
    ) {}

    public closeDialog() {
        this.modalRef.close();
    }

    public requestEgui() {
        this.store.dispatch(PrintEgui({ eguiModal: true }));
        this.modalRef.close();
    }
}
